import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle2, TrendingUp, Shield, BarChart3, ChevronRight, Briefcase, Calendar, ChevronDown, Phone, Mail, User, CheckCircle, ArrowRight, Home, PieChart } from "lucide-react";
import SplitText from '../components/reactbits/SplitText';

const Spolupraca = () => {
  return (
    <div className="min-h-screen bg-background font-body text-brand-dark-blue overflow-x-hidden">
      {/* Hero Section */}
      <section className="relative min-h-[90vh] flex items-center justify-center overflow-x-clip bg-brand-dark-blue border-b border-brand-gray/10 text-white">
        <div
          className="absolute inset-0 opacity-20 pointer-events-none"
          style={{ backgroundImage: 'url(/spolupraca_hero.jpg)', backgroundSize: 'cover', backgroundPosition: 'center' }}
        />
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-brand-dark-blue/80 via-brand-dark-blue/95 to-brand-dark-blue" />
        <div className="absolute top-1/3 left-1/4 w-[500px] h-[500px] bg-brand-orange/10 rounded-full blur-[150px] pointer-events-none" />

        <div className="container px-4 md:px-6 relative z-10 max-w-full min-w-0">
          <div className="flex flex-col items-center text-center space-y-6 sm:space-y-8 max-w-5xl mx-auto min-w-0 px-1">
            <div className="inline-block px-3 sm:px-4 py-1.5 rounded-full bg-brand-baby-blue/10 border border-brand-baby-blue/20 text-brand-baby-blue text-xs sm:text-sm font-semibold tracking-wide uppercase mb-2 backdrop-blur-sm max-w-full">
              Wealth Management & Majetkový poriadok
            </div>

            <div className="font-heading text-3xl min-[400px]:text-4xl sm:text-5xl md:text-6xl lg:text-8xl font-bold tracking-tight leading-[1.1] text-white break-words w-full max-w-full">
              Poriadok v majetku.<br />
              <span className="text-brand-orange">Pokoj v živote.</span>
            </div>

            <p className="text-base sm:text-xl md:text-2xl text-gray-200 max-w-4xl mx-auto leading-relaxed font-light px-1">
              Pomáham ľuďom, ktorí už niečo vybudovali, dospieť k momentu, kedy ich majetok uživí lepšie ako ich práca.
              <br /><span className="text-brand-baby-blue font-medium tracking-wide">Systém, ktorý vám vráti voľný čas.</span>
            </p>

            <div className="flex flex-col sm:flex-row gap-5 pt-8">
              <Link
                to="/konzultace"
                className="inline-flex items-center justify-center gap-2 bg-brand-orange hover:bg-red-600 text-white text-lg font-bold py-5 px-10 rounded-2xl transition-all duration-300 transform hover:scale-105 hover:shadow-2xl shadow-lg border-0"
              >
                <span>Dohodnúť úvodnú konzultáciu</span>
                <ChevronRight className="w-5 h-5" />
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* NEW VISUAL CONTEXT - PHOTOS FIRST */}
      <section id="context" className="py-24 bg-white">
        <div className="container px-4 md:px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-32 items-center max-w-7xl mx-auto">

            <div className="relative group">
              <div className="grid grid-cols-2 gap-4">
                <div className="space-y-4">
                  <img src="/spoluprace_mentorvibe.jpeg" className="rounded-3xl shadow-xl w-full h-[350px] object-cover" alt="Vibe 1" />
                  <div className="bg-brand-orange/10 p-8 rounded-3xl">
                    <p className="text-brand-dark-blue font-heading font-bold text-2xl mb-2">3600+</p>
                    <p className="text-gray-600 text-sm uppercase tracking-widest font-bold">Spokojných klientov</p>
                  </div>
                </div>
                <div className="space-y-4 pt-12">
                  <div className="bg-brand-dark-blue p-8 rounded-3xl text-white">
                    <p className="font-heading font-bold text-2xl mb-2">20</p>
                    <p className="text-gray-400 text-sm uppercase tracking-widest font-bold">Rokov v biznise</p>
                  </div>
                  <img src="/spolupraca_hero.jpeg" className="rounded-3xl shadow-xl w-full h-[350px] object-cover" alt="Vibe 2" />
                </div>
              </div>
              {/* Decorative label */}
              <div className="absolute -bottom-6 -right-6 bg-white p-6 rounded-2xl shadow-2xl max-w-xs border border-gray-100 hidden md:block rotate-2">
                <p className="font-heading font-bold text-brand-dark-blue mb-2 text-lg italic">"Nekupujete produkty. Kupujete si svoj čas späť."</p>
              </div>
            </div>

            <div className="space-y-8">
              <h2 className="font-heading text-4xl lg:text-6xl font-bold text-brand-dark-blue leading-tight">
                Viac než len správa peňazí
              </h2>
              <p className="text-xl text-gray-600 leading-relaxed">
                Väčšina finančníkov sa sústredí na predaj. Ja sa sústredím na <strong>systém</strong>. Mojím cieľom nie je predať vám poistku, alebo iné finančné produkty, ale vytvoriť majetkovú štruktúru, vďaka ktorej dosiahnete nekonečnú rentu.
              </p>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 pt-6">
                <div className="flex gap-4">
                  <div className="w-12 h-12 rounded-2xl bg-orange-50 flex items-center justify-center text-brand-orange shrink-0">
                    <Home size={24} />
                  </div>
                  <p className="text-gray-700 font-medium">Ochrana rodinného majetku</p>
                </div>
                <div className="flex gap-4">
                  <div className="w-12 h-12 rounded-2xl bg-blue-50 flex items-center justify-center text-brand-dark-blue shrink-0">
                    <PieChart size={24} />
                  </div>
                  <p className="text-gray-700 font-medium">Investičné stratégie</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SYSTEMS SECTION */}
      <section className="py-24 bg-gray-50 relative overflow-hidden">
        <div className="container px-4 md:px-6 relative z-10">
          <div className="text-center mb-20 space-y-4 max-w-3xl mx-auto">
            <div className="inline-block px-4 py-2 bg-white border border-gray-200 rounded-full text-xs font-bold uppercase tracking-widest text-brand-orange mb-2">
              Piliere spolupráce
            </div>
            <h2 className="font-heading text-4xl lg:text-6xl font-bold text-brand-dark-blue">
              Nekonečná renta v praxi
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-7xl mx-auto">
            {/* 1. AUDIT */}
            <div className="group bg-white rounded-[3rem] p-10 h-full flex flex-col shadow-xl hover:shadow-2xl transition-all duration-500 border border-gray-100">
              <div className="w-20 h-20 rounded-[1.5rem] bg-gray-50 flex items-center justify-center text-brand-dark-blue mb-8 group-hover:bg-brand-dark-blue group-hover:text-white transition-all duration-500">
                <BarChart3 size={40} />
              </div>
              <h3 className="font-heading text-3xl font-bold text-brand-dark-blue mb-6">
                Majetkový poriadok
              </h3>
              <p className="text-gray-600 text-lg mb-8 flex-grow leading-relaxed">
                Zmapujeme každý cent, každú zmluvu a každú investíciu. Výsledkom je jeden dokument, v ktorom vidíte celú svoju finančnú prítomnosť aj budúcnosť.
              </p>
              <img src="/spolupraca_majetkovyporadek.jpeg" className="rounded-2xl w-full h-48 object-cover opacity-60 group-hover:opacity-100 transition-opacity" alt="Order" />
            </div>

            {/* 2. STRATEGY (FEATURED) */}
            <div className="group bg-brand-dark-blue text-white rounded-[3rem] p-10 h-full flex flex-col shadow-2xl ring-8 ring-brand-orange/10 relative overflow-hidden transform md:-translate-y-8 duration-500">
              <div className="absolute top-0 right-0 w-64 h-64 bg-brand-orange/20 rounded-full blur-[80px]" />

              <div className="w-20 h-20 rounded-[1.5rem] bg-brand-orange flex items-center justify-center text-white mb-8 group-hover:scale-110 transition-transform relative z-10 shadow-lg">
                <TrendingUp size={40} />
              </div>
              <h3 className="font-heading text-3xl font-bold text-white mb-6 relative z-10">
                Investičné portfólio
              </h3>
              <p className="text-gray-300 text-lg mb-8 flex-grow leading-relaxed relative z-10">
                Prestaňte kupovať "super tipy". Budujeme robustné portfólio, ktoré prežije krízy a dlhodobo poráža infláciu. Nízke poplatky, vysoká likvidita.
              </p>
              <img src="/spolupraca_investicnistategia.jpeg" className="rounded-2xl w-full h-48 object-cover relative z-10" alt="Strategy" />
            </div>

            {/* 3. RENTA */}
            <div className="group bg-white rounded-[3rem] p-10 h-full flex flex-col shadow-xl hover:shadow-2xl transition-all duration-500 border border-gray-100">
              <div className="w-20 h-20 rounded-[1.5rem] bg-green-50 flex items-center justify-center text-green-600 mb-8 group-hover:bg-green-600 group-hover:text-white transition-all duration-500">
                <CheckCircle size={40} />
              </div>
              <h3 className="font-heading text-3xl font-bold text-brand-dark-blue mb-6">
                Exit k rente
              </h3>
              <p className="text-gray-600 text-lg mb-8 flex-grow leading-relaxed">
                Nastavíme systém čerpania majetku tak, aby ste nikdy nepocítili strach, že peniaze dôjdu. Je to návod na život bez nutnosti pracovať pre peniaze.
              </p>
              <img src="/spolupraca_vinohradrelax.jpeg" className="rounded-2xl w-full h-48 object-cover opacity-60 group-hover:opacity-100 transition-opacity" alt="Freedom" />
            </div>
          </div>
        </div>
      </section>

      {/* EMOTIONAL GALLERY - NEW */}
      <section className="py-24 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center mb-16">
            <h3 className="text-3xl font-heading font-bold text-brand-dark-blue mb-6 italic">"Váš čas je najcennejšie aktívum, ktoré máte. Prestaňte ním plytvať na správu financií. Nechajte to na systém."</h3>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 auto-rows-fr">
            <div className="rounded-3xl overflow-hidden shadow-lg h-80">
              <img src="/spoluprace_mentorvibe.jpeg" className="w-full h-full object-cover transition-all duration-700 hover:scale-105" alt="Detail 1" />
            </div>
            <div className="rounded-3xl overflow-hidden shadow-lg h-80 md:mt-12">
              <img src="/pribeh_s3.jpeg" className="w-full h-full object-cover transition-all duration-700 hover:scale-105" alt="Detail 2" />
            </div>
            <div className="rounded-3xl overflow-hidden shadow-lg h-80">
              <img src="/spolupraca_cta.jpeg" className="w-full h-full object-cover transition-all duration-700 hover:scale-105" alt="Detail 3" />
            </div>
          </div>
        </div>
      </section>

      {/* PROCESS SECTION */}
      <section className="py-24 bg-brand-dark-blue text-white overflow-hidden relative">
        <div className="absolute top-0 right-0 w-full h-full opacity-5 pointer-events-none" style={{ backgroundImage: 'url(/symbol-3.svg)', backgroundSize: '400px', backgroundRepeat: 'repeat' }} />

        <div className="container mx-auto px-4 max-w-5xl relative z-10">
          <div className="text-center mb-20">
            <h2 className="text-4xl lg:text-6xl font-heading font-bold mb-4">
              Prvé kroky k poriadku
            </h2>
            <p className="text-gray-400 text-lg">Hovorme o vašich cieľoch, nie o produktových letákoch.</p>
          </div>
          <div className="grid grid-cols-1 gap-12">
            {[
              { num: '01', title: 'Úvodná káva / call', text: 'Zistíme, či vám viem pomôcť dosiahnuť vaše ciele. Krátko, úprimne a bez tlaku.' },
              { num: '02', title: 'Diagnostika a Stratégia', text: 'Prejdeme hĺbkovo váš majetok a navrhnem systém, ktorý mu dá hlavu a pätu.' },
              { num: '03', title: 'Pravidelné kormidlovanie', text: 'Moja práca nekončí podpisom. Som váš partner, ktorý dohliada na to, aby majetok rástol.' }
            ].map((step, i) => (
              <div key={i} className="flex gap-8 items-center group">
                <div className="text-6xl md:text-8xl font-black text-brand-orange/20 font-heading leading-none group-hover:text-brand-orange/40 transition-colors">{step.num}</div>
                <div className="space-y-2">
                  <h4 className="text-2xl md:text-3xl font-heading font-bold text-white">{step.title}</h4>
                  <p className="text-lg text-gray-400 max-w-2xl">{step.text}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-24 text-center">
            <Link
              to="/konzultace"
              className="inline-flex items-center justify-center gap-3 bg-brand-orange hover:bg-white hover:text-brand-dark-blue text-white font-black py-6 px-12 rounded-2xl shadow-2xl transition-all duration-500 transform hover:scale-110 text-xl"
            >
              <Calendar className="w-8 h-8" />
              <span>Rezervovať si môj čas</span>
            </Link>
            <p className="mt-8 text-gray-400 italic">"Poriadok je najlepší nástroj slobody."</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Spolupraca;
